<style lang="less" scoped>
  #header {
    display: none;
  }
  .hide {
    display: none;
  }
  #register {
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 60px 0;
    width: 100%;
    height: 100%;
    background: #fafafa;
    border: 1px solid #d9dde8;
    overflow-y: auto;
    .container {
      background: white;
      width: 360px;
      border-radius: 4px;
      border: 1px solid #d9dde8;
      form {
        padding: 0 16px 16px;
      }
      .logo-cover {
        text-align: center;
        margin-bottom: 12px;
        margin-top: 44px;
      }
      .main-title {
        font-size: 17px;
        text-align: center;
        margin: auto;
        display: block;
        margin-bottom: 44px;
      }
      .description {
        padding: 12px;
        font-size: 14px;
        border-radius: 4px;
        background: #f8f8f8;
        line-height: 16.8px;
        margin-bottom: 24px;
        color: #7a7a7a;
      }
      .section {
        margin-bottom: 24px;
        .title {
          font-weight: bold;
          margin-bottom: 16px;
          font-size: 14px;
        }
        > .register-input {
          margin-bottom: 16px;
        }
        > .register-input:last-child {
          margin-bottom: 0;
        }
        .file-label {
          width: 100%;
          display: flex;
          align-items: center;

          .file-upload-button {
            margin-right: 16px;
            border: 1px solid #7ed321;
            color: #7ed321;
          }
        }
      }
    }
    .register-submit-button {
      width: 100%;
    }
  }
  .logo-cover {
    text-align: center;
    margin-bottom: 44px;
    > img {
      width: 197px;
    }
  }
  @media screen and (max-width: 560px) {
  #register {
    background: white;
    display: block;
    #header {
      display: flex;
    }
    .container {
      border: none;
      width: 100%;
      margin-top: 24px;
      .main-title {
        display: none;
      }
      .logo-cover {
        display: none;
      }
    }
  }
}
.fileinfo {
  flex: 1;
  > div {
    width: 100%;
    word-break: break-all;
  }
}
</style>

<template lang="pug">
  #register
    header-component(:title="title")
    .container
      form(@submit.prevent="submit")
        .logo-cover
          img(src="@/assets/happytree-mobile@2x.png")
        strong.main-title 회원가입
        .description
          strong 행복나무 원외탕전실에 오신것을 환영합니다.
          div.
            탕전실 이용에 앞서 계정을 만들고, 신분증을 확인하는 절차가 진행됩니다.
             아래 가입 신청서를 제출해주시면 빠른 시일 내에 내용을 검토하여 승인 여부를 이메일로 알려드리겠습니다.
        .section
          .title 회원 유형 선택
          el-radio(v-model="type" label="doctor") 사업자 (한의사)
          el-radio(v-model="type" label="student") 학생
        .section
          .title 기본 정보
          el-input.register-input(type="text", v-model="name", placeholder="성명")
          el-input.register-input(type="email", v-model="email", placeholder="이메일")
          el-input.register-input(type="tel", v-model="phoneNumber",  placeholder="전화번호")
          el-input.register-input(type="password", v-model="password", placeholder="비밀번호")
        .section(v-if="type == 'doctor'")
          .title 사업자 등록증 (사진)
          input.hide#photo1(
            type="file",
            @change="uploadBusinessRegistration",
            ref="businessRegistration")
          label.file-label(for="photo1")
            el-button.file-upload-button(
              type="default",
              @click="focusObject($refs.businessRegistration)") 파일 선택
            div.fileinfo
              div {{tempBusinessResistration || '선택된 파일이 없습니다.'}}
        .section(v-if="type == 'doctor'")
          .title 한의사 면허증 (사진)
          input.hide#photo2(
            type="file",
            @change="uploadDoctorLicense",
            ref="doctorLicense")
          label.file-label(for="photo2")
            el-button.file-upload-button(
              type="default",
              @click="focusObject($refs.doctorLicense)") 파일 선택
            div.fileinfo
              div {{tempDoctorLicense || '선택된 파일이 없습니다.'}}
        .section(v-if="type == 'student'")
          .title 학생증 (사진)
          input.hide#photo3(
            type="file",
            @change="uploadStudentIDCard",
            ref="studentIDCard")
          label.file-label(for="photo3")
            el-button.file-upload-button(
              type="default",
              @click="focusObject($refs.studentIDCard)") 파일 선택
            div.fileinfo
              div {{tempStudentIDCard || '선택된 파일이 없습니다.'}}
        el-button.register-submit-button(type="success" native-type="submit") 가입 신청
</template>

<script>
import headerComponent from '@/components/header';

export default {
  props: {
    title: {
      type: String,
    },
  },
  watch: {
    title(value) {
      this.$store.commit('setTitle', value);
    },
  },
  data() {
    return {
      type: 'doctor',
      businessRegistration: null,
      tempBusinessResistration: null,
      doctorLicense: null,
      tempDoctorLicense: null,
      studentIDCard: null,
      tempStudentIDCard: null,
      name: null,
      email: null,
      phoneNumber: null,
      password: null,
    };
  },
  components: {
    headerComponent,
  },
  methods: {
    async submit() {
      const payload = {
        type: this.type,
        name: this.name,
        email: this.email,
        phoneNumber: this.phoneNumber,
        password: this.password,
      };
      if (this.type === 'doctor') {
        payload.businessRegistration = this.businessRegistration;
        payload.doctorLicense = this.doctorLicense;
      } else {
        payload.studentIDCard = this.studentIDCard;
      }

      let msg = '';
      Object.keys(payload).forEach((key) => {
        const check = payload[key];
        if (check === null) {
          msg = '입력되지 않은 데이터가 존재합니다.';
        }
      });
      if (msg) {
        alert(msg);
        return false;
      }
      try {
        await this.$http.post('/users', payload);
        alert('회원 가입 신청이 완료되었습니다. 24시간 내로 승인이 완료되면 이용 가능합니다.');
        this.$router.push('/login');
      } catch (e) {
        const message = e.response.data.message;
        alert(message);
        return false;
      }

      return true;
    },
    async upload(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      const { data } = await this.$http.post('/upload', formData);
      return data.location;
    },
    async uploadBusinessRegistration(e) {
      this.tempBusinessResistration = e.target.files[0].name;
      const imageUrl = await this.upload(e);
      this.businessRegistration = imageUrl;
    },
    async uploadDoctorLicense(e) {
      this.tempDoctorLicense = e.target.files[0].name;
      const imageUrl = await this.upload(e);
      this.doctorLicense = imageUrl;
    },
    async uploadStudentIDCard(e) {
      this.tempStudentIDCard = e.target.files[0].name;
      const imageUrl = await this.upload(e);
      this.studentIDCard = imageUrl;
    },
    focusObject(obj) {
      obj.click();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/register.vue